import { detailsSmall, h5, paragraph } from "@/styles/typography";
import styled from "styled-components";

const Wrapper = styled.div`
  position: relative;
  a,
  a:visited {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primary};
  }

  a {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #a0a0a0;
    width: 100%;

    align-items: center;
    padding: 10px 20px;

    transition: all 0.2s ease-in-out;

    @media ${({ theme }) => theme.breakpoints.hover} {
      &:hover {
        box-shadow: inset 0px -4px 0px ${({ theme }) => theme.colors.primary};
      }
    }
  }
  max-width: 475px;
  margin-bottom: 10px;
`;

const Link = styled.a``;

const LeftWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 0.5rem;
`;

const Date = styled(detailsSmall)`
  text-transform: uppercase;
  margin-bottom: 5px;
  min-width: 80px;
  font-weight: 400;
`;

const Category = styled(paragraph)`
  margin-bottom: 5px;
`;

const RightWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled(h5)`
  margin: 0 !important;
  margin-right: 1rem !important;
  margin-bottom: 0.5rem !important;
  padding: 0;
  max-width: 300px;
`;

const Arrow = styled.img`
  height: 18px;
  transition: all 0.2s ease-in-out;
  margin-bottom: 1rem;
`;

const S = {
  Wrapper,
  Link,
  LeftWrapper,
  Date,
  Category,
  RightWrapper,
  Title,
  Arrow,
};

export default S;
